import {createFileRoute} from '@tanstack/react-router';
import TournamentsView from '../../../../tournaments/TournamentsView.tsx';

export const Route = createFileRoute('/_app/basketball/tournaments/$tournament_uid/$page')({
    component: RouteComponent,
})

function RouteComponent() {
    return <TournamentsView />
}
